import React from 'react';

export default function RearEngineIcon() {
  return (
   <svg fill="none" viewBox="0 0 65 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m35.586 0c-13.835 0-26.782 6.8142-34.615 18.218-1.6826 2.4497 0.07125 5.782 3.0431 5.782h58.985c1.1046 0 2-0.8954 2-2v-20.946c0-0.5819-0.4717-1.0536-1.0536-1.0536h-28.36zm13.414 2.88c-1.1046 0-2 0.89543-2 2v3.68c0 1.1046 0.8954 2 2 2h10c1.1045 0 2-0.89543 2-2v-3.68c0-1.1046-0.8955-2-2-2h-10z" clipRule="evenodd" fill="#194245" fillRule="evenodd" />
   </svg>
  );
}
